const notificationTypes = {
  SAVE_SINGLE_NOTIFICATION: 'SAVE_SINGLE_NOTIFICATION',
  UPDATE_NOTIFICATION_STATUS: 'UPDATE_NOTIFICATION_STATUS'
};

export default notificationTypes;
